export default __webpack_public_path__ + "static/logo-slupsk-d92330f040563c9327048893a7899073.png";